import {defineMessages} from 'react-intl';

const messages = defineMessages({
  reportIssueTitle: {
    id: 'reportIssue',
    defaultMessage: 'Report Issue'
  },
  reportIssueDescription: {
    id: 'reportIssueDescription',
    defaultMessage: 'You are about to alert the system about an issue.'
  },
  submitIssue: {
    id: 'submitIssue',
    defaultMessage: 'Submit issue'
  },
  reportedCheck: {
    id: 'reportedCheck',
    defaultMessage: 'This check was reported'
  },
  mediaNotInserted: {
    id: 'mediaNotInserted',
    defaultMessage: 'Media not inserted'
  },
  noFeedback: {
    id: 'noFeedback',
    defaultMessage: 'No feedback text'
  },
  somethingWentWrongPa: {
    id: 'somethingWentWrongPa',
    defaultMessage: 'Something went wrong. Please contact your platform admin.'
  },
  somethingWentWrong: {
    id: 'somethingWentWrong',
    defaultMessage: 'Something went wrong. Please try again.'
  },
  uploadNew: {
    id: 'uploadNew',
    defaultMessage: 'Upload new'
  },
  saveWithoutNewFile: {
    id: 'saveWithoutNewFile',
    defaultMessage: 'Save without new file'
  },
  fileStillUploadingTitle: {
    id: 'fileStillUploadingTitle',
    defaultMessage: 'File upload in progress'
  },
  fileStillUploadingSubtitle: {
    id: 'fileStillUploadingSubtitle',
    defaultMessage: 'Your file upload is still in progress. Do you want to save your feedback without the new file?'
  },
  couldNotUploadFileTitle: {
    id: 'couldNotUploadFileTitle',
    defaultMessage: 'Could not upload file'
  },
  couldNotUploadFileSubtitle: {
    id: 'couldNotUploadFileSubtitle',
    defaultMessage: 'The file could not be uploaded because of an error.'
  },
  tooLarge: {
    id: 'fileTooLarge',
    defaultMessage: 'The file could not be uploaded because it is larger than {allowedSize} MB.'
  },
  tryAgain: {
    id: 'tryAgain',
    defaultMessage: 'Try again'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  describeIssue: {
    id: 'describeIssue',
    defaultMessage: 'Describe the issue you are experiencing'
  },
  fileNotSupported: {
    id: 'fileNotSupported',
    defaultMessage: 'The file could not be uploaded because the file format is not supported.'
  },
  delete: {
    id: 'common.actions.delete',
    defaultMessage: 'Delete'
  },
  removeFileSubtitle: {
    id: 'removeFileSubtitle',
    defaultMessage: 'Are you sure you want to delete this file?'
  },
  removeFileTitle: {
    id: 'removeFileTitle',
    defaultMessage: 'Delete file'
  },
  details: {
    id: 'details',
    defaultMessage: 'Details'
  }
});

export default messages;
